{
  "assignments": {
    "withdraw": {
      "action": "無法擔任評審？退出本競賽評審",
      "dialogTitle": "退出本競賽的評審工作",
      "dialogTarget": "{{count}} 件尚未送出評分的作品",
      "dialogScope": "取消您在本競賽所有尚未送出評分的指派；已送出的評分不受影響。",
      "dialogImpact": "您無法自行恢復，需由主辦方重新指派；退出原因會記錄並讓主辦方看到。",
      "dialogConfirm": "確認退出",
      "dialogSuccessLeft": "已退出並放棄這場競賽的評審身分，主辦方需要重新邀請您才能再次擔任。",
      "leaveRole": "同時放棄這場競賽的評審身分（之後主辦方需重新邀請您）",
      "dialogSuccess": "已退出本競賽的評審工作，主辦方會重新安排。"
    },
    "links": {
      "profile": "我的評審資料",
      "history": "評分紀錄"
    },
    "announcements": {
      "title": "公告"
    },
    "progress": {
      "label": "已完成 {{done}} / {{total}}",
      "aria": "評審整體完成進度"
    },
    "title": "評審指派",
    "description": "指派的作品以匿名代碼識別，此頁面不會顯示其他評審的分數或排名。",
    "loading": "載入指派中…",
    "noCompetition": "請先選擇競賽以查看評審指派。",
    "competitionLabel": "競賽",
    "selectCompetitionPlaceholder": "請選擇競賽…",
    "empty": "目前尚無指派項目。",
    "error": "無法載入您的評審指派。",
    "noJudgeCompetitions": "您目前尚未被指派為任何競賽的評審。",
    "accessDenied": {
      "title": "無法進入這場競賽的評審工作區",
      "description": "你目前無法以此角色進入這場競賽。",
      "back": "返回評審指派"
    },
    "roundsTablist": "賽程輪次",
    "workTitle": "作品 {{code}}",
    "round": "輪次：{{name}}",
    "rubricVersion": "評分規準：{{name}}",
    "currentTotal": "目前總分 {{total}} / 100（僅本人可見）",
    "savedAt": "草稿 · 已儲存 {{time}}",
    "competitionOptionPending": "{{count}} 件待評",
    "statusBadge": {
      "not_started": "尚未開始",
      "draft": "草稿",
      "submitted": "已送出"
    },
    "cta": {
      "start": "開始評分",
      "continue": "繼續評分",
      "view": "查看評分"
    },
    "summary": {
      "pending": "待評 {{count}}",
      "draft": "草稿 {{count}}",
      "submitted": "已送出 {{count}}"
    },
    "filters": {
      "label": "篩選狀態",
      "all": "全部",
      "pending": "待評",
      "draft": "草稿",
      "submitted": "已送出"
    },
    "conflict": {
      "declareAction": "申報利益衝突",
      "declaredBadge": "已申報迴避",
      "blockedFromScoring": "您已無法評分此作品。",
      "dialogTitle": "申報利益衝突",
      "dialogScope": "僅此項評審指派",
      "dialogImpact": "申報後將立即無法評分此作品，並通知主辦方重新指派評審。",
      "dialogConfirm": "申報利益衝突",
      "dialogSuccess": "已申報利益衝突，您已無法評分此作品。"
    },
    "noScoringNeeded": {
      "badge": "無需評分"
    }
  },
  "terms": {
    "title": "評審須知與保密確認",
    "intro": "開始評審前，請確認您了解並同意以下規則。每場競賽只需確認一次。",
    "rules": {
      "confidentiality": {
        "title": "保密",
        "body": "作品內容與參賽者相關資訊僅供本次評審使用，不得下載、轉傳、公開分享或用於評分以外的目的。"
      },
      "conflict": {
        "title": "利益迴避",
        "body": "若與參賽者有指導、親屬、雇用等可能影響公正的關係，請先在「評審任務」申報利益衝突，並且不得評分該件作品。"
      },
      "anonymity": {
        "title": "匿名與公平",
        "body": "作品以匿名代碼呈現，請勿嘗試辨識參賽者身分；外部連結與影片由參賽者控制，建議以無痕視窗開啟。"
      },
      "scoring": {
        "title": "評分方式",
        "body": "依評分規準逐項給分，草稿會自動儲存；「正式送出」後分數即鎖定，如需修改請聯絡主辦方。"
      },
      "deadline": {
        "title": "截止時間",
        "body": "請在審查截止時間前完成所有評分，剩餘時間會顯示在評審任務頁。"
      }
    },
    "guideHint": "完整說明請見",
    "guideLink": "評審操作手冊",
    "agree": "我已閱讀並同意遵守上述保密與利益迴避規範",
    "confirm": "確認並開始評審",
    "error": "無法記錄您的確認，請稍後再試。",
    "scoreBlocked": "請先到評審任務頁完成評審須知確認，才能開始評分。",
    "scoreBlockedLink": "前往評審任務"
  },
  "profile": {
    "title_page": "我的評審資料",
    "description": "這些資料會顯示給這場競賽的主辦方（評審名單），不會顯示給參賽者或其他評審。每場競賽各自保存。",
    "identityNote": "姓名與 Email 請至帳號選單的「帳號與安全」修改。",
    "organization": "服務單位",
    "title": "職稱",
    "expertise": "專長（以逗號分隔）",
    "bio": "簡介",
    "save": "儲存",
    "saved": "已儲存。",
    "error": "儲存失敗，請確認內容後再試。",
    "unavailable": "目前無法讀取評審資料。"
  },
  "history": {
    "title": "評分紀錄",
    "description": "您在所有競賽中已送出的評分。草稿與未開始的作品請回評審任務頁處理。",
    "submittedOf": "已送出 {{done}} / {{total}}",
    "average": "平均總分 {{value}}",
    "none": "尚未送出任何評分",
    "view": "查看"
  },
  "deadline": {
    "label": "審查截止：{{time}}",
    "remaining": "還剩 {{amount}}",
    "overdueBy": "已逾期 {{amount}}，請儘快完成並聯絡主辦方",
    "overdueBadge": "已逾期",
    "daysHours": "{{days}} 天 {{hours}} 小時",
    "hours": "{{hours}} 小時",
    "underOneHour": "不到 1 小時"
  },
  "score": {
    "loading": "載入評分資料中…",
    "description": "評分草稿僅您本人可見，送出後將永久鎖定此評分。",
    "titleShort": "作品 {{code}}",
    "rubric": "評分規準",
    "rubricDescription": {
      "show": "查看評分說明",
      "hide": "隱藏評分說明"
    },
    "currentTotal": "目前總分 {{total}} / 100",
    "completion": "完成度 {{done}} / {{total}}",
    "overallComments": "個人評審備註",
    "commentNote": "僅您本人可見，不會顯示給其他評審或參賽者。",
    "reviewComment": "審查意見",
    "reviewCommentNote": "您與競賽主辦單位可見，不會顯示給其他評審或參賽者。",
    "reviewCommentRequiredMark": "（必填）",
    "reviewCommentRequiredError": "此競賽要求送出評分前必須填寫審查意見。",
    "saveDraft": "儲存草稿",
    "submitScore": "送出評分",
    "submitConfirm": "確定要送出並鎖定此評分嗎？",
    "back": "返回評審任務",
    "files": "作品檔案",
    "tabFiles": "簡報與檔案",
    "tabVideo": "影片",
    "workViewLabel": "作品檢視方式",
    "links": "作品連結",
    "workNavLabel": "作品切換",
    "previous": "上一件",
    "nextInOrder": "下一件",
    "position": "第 {{index}} / {{total}} 件",
    "shortcutsHint": "快捷鍵：Ctrl/⌘+S 儲存草稿 · Ctrl/⌘+Enter 送出 · Alt+←/→ 上一件／下一件。系統也會在您停止輸入後自動儲存草稿。",
    "externalNotice": "以下為外部連結，內容由參賽者控制，可用性可能變動；為保護匿名評審，建議以無痕視窗開啟。",
    "externalHost": "外部連結 · {{host}}",
    "noFiles": "此作品尚無上傳檔案。",
    "saveSuccess": "草稿已儲存。",
    "submitSuccess": "評分已送出並鎖定。",
    "saveError": "儲存失敗，請確認分數後重試。",
    "submitError": "送出失敗，請確認分數後重試。",
    "scoreOutOfRange": "「{{name}}」分數必須介於 {{min}} 到 {{max}} 之間。",
    "state": {
      "unsaved": "草稿 · 尚未儲存",
      "saving": "正在儲存…",
      "savedAt": "草稿 · 已儲存於 {{time}}",
      "submitted": "已送出 · {{time}}"
    },
    "completionGate": {
      "complete": "✓ 所有必填評分項目已完成",
      "incomplete": "尚有 {{count}} 項必填評分未完成",
      "reviewCommentMissing": "尚未填寫審查意見"
    },
    "reviewMode": {
      "title": "評分已鎖定",
      "totalLabel": "總分",
      "finalTotal": "最終總分 {{total}} / 100",
      "scoresCompleted": "{{count}} 項評分完成",
      "completedHeading": "✓ 本件評分已完成"
    },
    "weightedContribution": "加權 {{value}}",
    "anonymousTag": "匿名代碼 {{code}}",
    "nextAssignment": "下一件待評作品",
    "nextAssignmentNone": "目前沒有其他待評作品",
    "confirmDialog": {
      "title": "確認送出評分",
      "description": "送出後將永久鎖定，無法再自行修改分數或評語。",
      "totalLabel": "目前總分",
      "commentBlankWarning": "評語尚未填寫。",
      "commentStatus": {
        "blank": "評語：未填寫",
        "filled": "評語：已填寫"
      },
      "reviewCommentStatus": {
        "blank": "審查意見：未填寫",
        "filled": "審查意見：已填寫"
      },
      "cancel": "取消",
      "confirm": "確認送出",
      "working": "送出中…"
    },
    "noScoringNeeded": {
      "title": "此作品無需評分",
      "body": "此作品的隊伍已不在本次評比中，您的評分不會被計入，無需評分。若有疑問，請與主辦方聯絡。"
    }
  }
}
